export enum LoginSteps {
    REGISTER ,
    CONFIRMATION ,
}
